var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h26v26H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 13c0 7.18-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0s13 5.82 13 13",
    fill: "#fff",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 16.9H7.8c-1.8 0-3.361.931-4.293 2.323 2.038 3.083 5.53 5.123 9.494 5.123 3.962 0 7.454-2.04 9.491-5.123C21.56 17.831 20 16.9 18.2 16.9M18.282 10.156a5.281 5.281 0 1 1-10.563 0 5.281 5.281 0 0 1 10.563 0",
    fill: "#DA291C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLight);
export default __webpack_public_path__ + "static/media/account-light.4df2baae9c368779647f219c5cee31e5.svg";
export { ForwardRef as ReactComponent };